export default {
  superDesktop: 'Relatório',
  home: 'Casa',
  people: 'Pessoas',
  directory: 'CRM',
  lists: 'Listas',
  roles: 'Papéis',
  segments: 'Segmentos',
  businesses: 'Empresas',
  talk: 'Fale',
  chats: 'Conversas',
  conversationMetrics: 'Métricas',
  conversationSettings: 'Configuração de bate-papo',
  communicate: 'Comunicar',
  campaigns: 'Campanhas',
  triggers: 'Gatilhos',
  notifications: 'Notificações',
  connect: 'Conectar',
  authenticator: 'Autenticador',
  forms: 'Forms',
  oAuths: 'Oauths',
  crm: 'Crm',
  /* events */
  events: 'Eventos',
  myEvents: 'Meus Eventos',
  categories: 'Categorias',
  assistants: 'Assistentes',
  promotors: 'Promotores',
  djs: 'Djs',
  productsCategories: 'Categorias de produtos',
  products: 'Produtos',
  places: 'Lugares',
  /* ORDERS */
  clients: 'Clientes',
  colors: 'Cores',
  containerTypes: 'Tipos de Containers',
  purchases: 'Compras',
  sellers: 'Vendedores',
  suppliers: 'Fornecedores',
  /* microsites */
  microSites: 'Micro sites',
  configure: 'Configurar',
  generalities: 'Generalidades',
  apps: 'Apps',
  administrators: 'Administradores',
  billing: 'Faturamento',
  graphicAspect: 'Aspecto Gráfico',
  automate: 'Automatizar',
  following: 'Segue',
  mainTables: 'Tabelas principais',
  panel: 'Painel',
  journeyLeads: 'Leads de jornada',
  sequences: 'Sequências',
  userConfiguration: 'Configuração do usuário'
}
